module.exports = __webpack_public_path__ + "img/landing-image.acd66881.jpg";